import React from 'react'

import {
  DateTimePicker
} from '@material-ui/pickers';
import { Typography, Box } from '@material-ui/core'

const DatetimePicker = (props) => {
  const {
    label = '',
    labelClass = '',
    ...restProps
  } = props

  return (
    <Box>
      {label &&
        <Typography className={labelClass}>
          {label}
        </Typography>
      }
      <DateTimePicker style={{ width: '100%' }} {...restProps} />
    </Box>
  )
}

export default DatetimePicker